import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'sqa-helpguide',
  templateUrl: './sqa-helpguide.component.html',
  styleUrls: ['./sqa-helpguide.component.css']
})
export class SqaHelpguideComponent implements OnInit {
  @Output() closeHelpGide = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }
  closeNav(){
    this.closeHelpGide.emit();
  }
}
